export default __webpack_public_path__ + "static/media/truck.b002bd04.svg";